export default __webpack_public_path__ + "static/media/background.18624a8e.jpg";